export default class TextFormat {
  static capitalizeFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }
}
